import * as types from './types';
import { JSON_STRING, HttpClient, MHTTPCL } from '../../../../services/http/http-client';
import { setMainNavInactive } from '../../../../store/app/mutations';
import { getNavTabModule } from '../../../../dt-plugins/sidewindow/nav-tab';
import router from '../../../../router';
import { taskService } from '../../services/tasks.service';
import { type } from 'ramda';

const NavTabModule = getNavTabModule(types.TasksDetails, 'tasksDetails');

export const tasksActions = {
  

  
    
    async [types.TasksList.FETCH.ALL]({ commit, getters, dispatch }, payload) {
      const { start, row_count, searchMode, basicFilter, searchFilter } = payload;
  
      const row_start =start;
      let res;
      console.log("PAYLOAD",payload);
      
      if (searchMode == 'none') {
        if (start == 0) {
          res = await HttpClient.mergeRequests([
            taskService.taskList(basicFilter.status,basicFilter.assigned_users,basicFilter.start,basicFilter.end),
            taskService.tasksTab()
          ]);
  
          console.log("RES1",res)
  
          commit(types.TasksList.SET.ALL,  {
            ...getters.tasksList,
            ...res
          } );  // <-- Directly Set the Data. Depends on your particular Logic
        // } else {                // <-- Pagination Logic
        //   res = await licenceAccountsService.licenceAccountList(start,row_count);            // <-- Pagination Logic
          
        //   console.log("res",res)
        
        //   commit(types.LicenceAccountsList.SET.ALL, { // <-- Set the Data. Here the actual List is nested. Depends on your particular case
        //     ...getters.licenceAccountsList,
        //     licence_accounts: [
        //       ...getters.licenceAccountsList.licence_accounts,
        //       ...res.data.licence_accounts, // <-- append new Fetched List
        //     ]
        //   });
  
          // Setting EOL
          // if (!(res?.data?.length <= 0)) {
          //   return EOL_REACHED;
          // }
        }
  
      }else if (searchMode == 'basic') {
          const {   searchString ,status,sent_user,start,end,assigned_users,chapter } = basicFilter;
          
          res = await taskService.taskListSearch(searchString,row_start,row_count,chapter,sent_user,start,end,status,assigned_users);
          
        //  //res = await licenceAccountsService.searchLcncAccs(licence_statuses,searchString);
        //  console.log("Basic Search Res",res)
         
        //if (start == 0) {
          console.log(basicFilter,":::::::::AAAAA",res.data.tasks,start);
          commit(types.TasksList.SET.ALL,  {
            
            ...getters.tasksList,
            tasks:res.data.tasks,
          });
        //} 
        // else {                // <-- Pagination Logic
        //   commit(types.LicenceAccountsList.SET.ALL, { // <-- Set the Data. Here the actual List is nested. Depends on your particular case
        //     ...getters.licenceAccountsList,
        //     licence_accounts: [
        //       ...getters.licenceAccountsList.licence_accounts,
        //       ...res.data.licence_accounts, // <-- append new Fetched List
        //     ]
        //   });
        // }
        // Setting EOL
        // if (!(res?.data?.length > 0)) {
        //   return EOL_REACHED;
        // }
      } else if (searchMode == 'advanced') {
        console.log({ "searchFilter": searchFilter });
        const { search ,start , end , sent_user ,status } =searchFilter;
        // const {   searchString  } = basicFilter;
        res = await taskService.taskListAdvanceSearch(search,sent_user,start,end,status);
        console.log("DATA",res);
        if (start == 0) {
          //console.log(searchString,":::::::::AAAAA",res.data.tasks,start); 
          commit(types.TasksList.SET.ALL,  {
            
            ...getters.tasksList,
            tasks:res.data.tasks,
          });
        } 
        //else {
        //   commit(types.LicenceAccountsList.SET.ALL, { // <-- Set the Data. Here the actual List is nested. Depends on your particular case
        //     ...getters.licenceAccountsList,
        //     licence_accounts: [
        //       ...getters.licenceAccountsList.licence_accounts,
        //       ...res.data.licence_accounts, // <-- append new Fetched List
        //     ]
        //   });
        // }
        // Setting EOL
        // if (!(res?.data?.length > 0)) {
        //   return EOL_REACHED;
        // }
      }
  
        //const statementOverviewData = await HttpClient.mergeRequests(promises);
      
      //console.log("StatementOverviewData",statementOverviewData);
  
       //commit(types.BelieveStatementList.SET.ALL,  statementOverviewData );
    },

    async [types.TasksList.INSERT.SINGLE]({ commit, getters, dispatch }, payload){
      
      delete payload.assigned_user;
      const res = await taskService.addTaskUser(payload);

      const taskList = await taskService.taskList();
      console.log(taskList,"PYALOADOPJHKJ")
      commit(types.TasksList.SET.ALL,  {
        ...getters.tasksList,
        tasks:taskList.data.tasks
      } ); 
    },


    async [types.TasksList.UPDATE.SINGLE]({ commit, getters, dispatch }, payload){
      // const res = await taskService.addTaskUser(payload);
      const { item , value , name,namevalue} =payload
      const { task_id } = item
      console.log('getters.tasksList,:::::::',payload)
      // const taskList = await taskService.taskList();
      //console.log(taskList,"PYALOADOPJHKJ")
      if(name=='entry'){
        commit(types.TasksList.SET.ALL,  {
          ...getters.tasksList,

          tasks:getters.tasksList.tasks.map(x=>{
           //console.log(":PSKKDKDKDKDK",x)
            if(x.task_id==task_id){
                return {
                  ...item
                }
            }else{
              return {
                ...x
              }
            }
          }),
        });
        
        return ;
      }
      
      
      
      
      
      
      commit(types.TasksList.SET.ALL,  {
        ...getters.tasksList,

        tasks:getters.tasksList.tasks.map(x=>{
          if(x.task_id==task_id){
            if(name=='assigned_users'){
              return {
                ...x,
                [name]:value,
                users:namevalue
              }

            }else{
              return {
                ...x,
                [name]:value
              }
            }
            

          }else{
            return {
              ...x
            }
          }
        }),
      }); 

      MHTTPCL.modify(undefined,task_id,name,value,'tasks_user');
    }
   
  }